function injectStyle (ssrContext) {
  require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-6f69c8b3\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BindGroupLevel.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BindGroupLevel.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6f69c8b3\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BindGroupLevel.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6f69c8b3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/user/BindGroupLevel.vue
// module id = 1543
// module chunks = 8